import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"row","padding-right":"64px","margin-bottom":"16px"} }

import { Co2QuizAnswer, Co2QuizQuestion } from '@/models/co2-quiz.model';
import { Mutations, ShiftCMSState } from '@/store';
import { computed, markRaw, watch } from 'vue';
import { useStore } from 'vuex';
import {
  Co2QuizStoreActions,
  Co2QuizStoreMutations,
  Co2QuizStoreState,
} from '@/stores/co2-quiz.store';
import Co2Question from '@/components/co2quiz/Co2Question.vue';
import { SimpleUserCo2QuizAnswer } from '@/models/user.model';
import Co2QuizResults from '@/components/co2quiz/Co2QuizResults.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Co2CalculatorForm',
  setup(__props) {

const store = useStore<ShiftCMSState & { co2: Co2QuizStoreState }>();
const questions = computed<Co2QuizQuestion[]>(() => store.state.co2.questions);
const answers = computed<SimpleUserCo2QuizAnswer[]>(
  () => store.state.co2.answers,
);

watch(
  () => answers.value,
  () => {
    store.dispatch(Co2QuizStoreActions.UpdateResults, answers.value);

    store.commit(Mutations.ShowSubDrawer, {
      component: markRaw(Co2QuizResults),
      data: questions,
      small: true,
    });
  },
);

const followQuestions = computed<number[]>(() =>
  questions.value.reduce((acc: number[], i: Co2QuizQuestion) => {
    const followUps: Co2QuizQuestion[] = i.answers
      .filter((a) => a.followUpQuestion)
      .map((a) => a.followUpQuestion)
      .filter((n) => !!n);
    return [...acc, ...followUps.map((f) => f.id)];
  }, []),
);

function showResults() {
  //
}

function selectAnswer(
  question: Co2QuizQuestion,
  answer: Co2QuizAnswer | null,
  inputValue?: string,
) {
  store.commit(Co2QuizStoreMutations.UpdateAnswer, {
    question,
    answer,
    inputValue,
  });
}

function reset() {
  store.commit(Co2QuizStoreMutations.ResetAnswers);
  store.commit(Mutations.HideSubDrawer);
}

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    onSubmit: _withModifiers(showResults, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Co2 Calculator", -1)),
            _createVNode(_component_v_spacer),
            _cache[2] || (_cache[2] = _createTextVNode()),
            _createVNode(_component_v_btn, {
              color: "warning",
              onClick: reset
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("Reset")
              ])),
              _: 1
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (q) => {
            return (_openBlock(), _createBlock(Co2Question, {
              question: q,
              selected: answers.value.find((a) => a.question.id === q.id) || null,
              followups: followQuestions.value,
              key: q.id,
              "onUpdate:answer": 
          ({ answer, inputValue }) => selectAnswer(q, answer, inputValue)
        
            }, null, 8, ["question", "selected", "followups", "onUpdate:answer"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})